import { RowExportTypePdf } from "types";
import { PdfTemplate } from "components";
import { ListShopTransactionAccess } from "../types";

export function PdfShopTransaction(props: {
  dataList: ListShopTransactionAccess[];
}) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "SHOP TRANSACTION", key: "shop_transaction", width: 10 },
    { header: "JOB POSITION", key: "job_position", width: 10 },
  ];

  const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => ({
    no: index + 1,
    shop_transaction: item?.shop_transaction?.shop_transaction_name ?? "-",
    job_position: item?.job_position?.job_position_name ?? "-",
  }));

  return (
    <PdfTemplate
      data={dataMap}
      column={columns}
      title="SHOP TRANSACTION ACCESS"
    />
  );
}
